import { createSlice } from '@reduxjs/toolkit';

const activitySlice = createSlice({
  name: 'activity',
  initialState: {
    activities: [],
    currentActivity: null,
    loading: false,
    detailLoading: false,
    saving: false,
    error: null,
    success: false,
  },
  reducers: {
    getActivitiesAction: (state) => {
      state.loading = true;
      state.error = null;
    },
    getActivitiesSuccess: (state, action) => {
      const responseData = action.payload?.data || action.payload?.results || [];
      state.activities = Array.isArray(responseData) ? responseData : [];
      state.loading = false;
      state.error = null;
    },
    getActivitiesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    createActivityAction: (state) => {
      state.saving = true;
      state.error = null;
      state.success = false;
    },
    createActivitySuccess: (state) => {
      state.saving = false;
      state.error = null;
      state.success = true;
    },
    createActivityFailure: (state, action) => {
      state.saving = false;
      state.error = action.payload;
    },
    updateActivityAction: (state) => {
      state.saving = true;
      state.error = null;
      state.success = false;
    },
    updateActivitySuccess: (state) => {
      state.saving = false;
      state.error = null;
      state.success = true;
    },
    updateActivityFailure: (state, action) => {
      state.saving = false;
      state.error = action.payload;
    },
    deleteActivityAction: (state) => {
      state.saving = true;
      state.error = null;
    },
    deleteActivitySuccess: (state) => {
      state.saving = false;
      state.error = null;
    },
    deleteActivityFailure: (state, action) => {
      state.saving = false;
      state.error = action.payload;
    },
    getActivityByIdAction: (state) => {
      state.detailLoading = true;
      state.error = null;
    },
    getActivityByIdSuccess: (state, action) => {
      state.currentActivity = action.payload?.data || action.payload;
      state.detailLoading = false;
      state.error = null;
    },
    getActivityByIdFailure: (state, action) => {
      state.detailLoading = false;
      state.error = action.payload;
      state.currentActivity = null;
    },
    clearCurrentActivity: (state) => {
      state.currentActivity = null;
    },
    resetActivityStatus: (state) => {
      state.success = false;
      state.error = null;
    },
  },
});

export const {
  getActivitiesAction,
  getActivitiesSuccess,
  getActivitiesFailure,
  createActivityAction,
  createActivitySuccess,
  createActivityFailure,
  updateActivityAction,
  updateActivitySuccess,
  updateActivityFailure,
  deleteActivityAction,
  deleteActivitySuccess,
  deleteActivityFailure,
  getActivityByIdAction,
  getActivityByIdSuccess,
  getActivityByIdFailure,
  clearCurrentActivity,
  resetActivityStatus,
} = activitySlice.actions;

export { activitySlice };
